PJQ.views.dailyReports.Survey = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey')
    },
    afterRender: function () {
        this.itemViews = [];
        _.each(this.model.surveyItems.models, function (surveyItem, index) {
            let itemEl = $('<div>');
            this.$('.survey-items').append(itemEl);

            let iv = new PJQ.views.dailyReports.SurveyItem({
                el: itemEl,
                model: surveyItem,
                dailyReport: this.model,
                project: this.options.project,
                index: index,
                isLocked: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.model.get('status') === 1
            });
            this.itemViews.push(iv);
        }, this);
    },
    validate: function () {
        let isValid = true;
        _.each(this.itemViews, function (itemView) {
            isValid = itemView.validate() && isValid;
        }, this);
        return isValid;
    }
});

PJQ.views.dailyReports.SurveyItem = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey-Item')
    },
    events: {
        'click .survey-answer>button': 'answerChanged',
        'keyup .survey-answer-note': 'answerNoteChanged'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminSurvey');
        this.options.canEdit = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAnswerSurvey') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            model: this.model,
            index: this.options.index,
            canEdit: this.options.canEdit,
            isValidate: this.options.isValidate
        };
    },
    afterRender: function () {
        this.renderAnswerButtonGroup();

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.survey-item-attachment-file-upload'),
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            sortDirection: 'asc',
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'survey',
                    value: this.model.id
                },
                {
                    endpoint: 'attachments'
                }
            ]),
            onSuccess: _.bind(function (file) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'survey',
                            value: this.model.id
                        },
                        {
                            endpoint: 'attachments'
                        }
                    ]),
                    data: file,
                }).put().done(_.bind(function (file) {
                }, this)).fail(onScriptError);
            }, this),
            collection: this.model.attachments
        });
    },
    answerChanged: function (e) {
        let selectedValue = $(e.currentTarget).data('value');
        this.model.set('answer', selectedValue.toString());
        this.renderAnswerButtonGroup();
        this.model.queueSave();
    },
    answerNoteChanged: function () {
        this.model.set('answerNote', this.$('.survey-answer-note').val());
        this.model.queueSave();
    },
    renderAnswerButtonGroup: function () {
        let self = this,
            answer = self.model.get('answer');
        if (answer != null) {
            answer = answer.toString();
        }

        this.$('.survey-answer>button').each(function () {
            if ($(this).data('value').toString() === answer) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });
    },
    validate: function () {
        this.options.isValidate = true;
        this.render();
        return this.model.isValid();
    }
});
